<div id="favouritesBase">
    <app-header [headerTitle]="'home.favourites' | translate" [navBack]="'true'" [accessActions]="false"></app-header>

    <div class="baseContainer">
        <div class="tabs">
            <a (click)="loadCatContent(0)" [title]="'home.games.0' | translate" [class.select]="selectCategory == 0">{{ 'home.games.1' | translate: { num: favourites$[0] ? '('+ favourites$[0].length +')' : '' } }}</a>
            <a (click)="loadCatContent(1)" [title]="'home.others.0' | translate" [class.select]="selectCategory == 1">{{ 'home.others.1' | translate: { num: favourites$[1] ? '('+ favourites$[1].length +')' : '' } }}</a>
        </div>

        <ngx-slick-carousel class="favouritesBox" #slickModal="slick-carousel" [config]="favSlideConfig" (afterChange)="catSwipe($event)">

            <main ngxSlickItem class="favouriteSlide"> 

                <div *ngFor="let fav of favourites$[0]" class="favourites">
                    <span (click)="doDislike(fav.id)" class="favorIcon"><i class="fas fa-heart"></i><i class="far fa-heart"></i></span>
                    <img [src]="fav.cmsProps?.slider_image_url" [alt]="fav.name">
                    <h6>{{ fav.name }} <span [innerHTML]="fav.cmsProps?.priceLabel"></span></h6>
                    <a routerLink="/voucher/{{ fav.contentId }}" class="btn">{{ 'home.buyVoucher' | translate }}</a>
                </div>

                <h5 *ngIf="favourites$[0] && !favourites$[0].length" class="text-center py-5 my-5">{{ 'home.noFavouritesFound' | translate }}</h5>
                <div *ngIf="!favourites$[0]" class="contentLoader my-5 py-5"><span></span></div>

            </main>

            <main ngxSlickItem class="favouriteSlide">

                <div *ngFor="let fav of favourites$[1]" class="favourites">
                    <span (click)="doDislike(fav.id)" class="favorIcon"><i class="fas fa-heart"></i><i class="far fa-heart"></i></span>
                    <img [src]="fav.cmsProps?.slider_image_url" [alt]="fav.name">
                    <h6>{{ fav.name }} <span [innerHTML]="fav.cmsProps?.priceLabel"></span></h6>
                    <a routerLink="/voucher/{{ fav.contentId }}" class="btn">{{ 'home.buyVoucher' | translate }}</a>
                </div>

                <h5 *ngIf="favourites$[1] && !favourites$[1].length" class="text-center py-5 my-5">{{ 'home.noFavouritesFound' | translate }}</h5>
                <div *ngIf="!favourites$[1]" class="contentLoader my-5 py-5"><span></span></div>

            </main>

        </ngx-slick-carousel>

    </div>

</div>